import React from 'react'
import './tooltip.styl'
import styled from 'styled-components'

class Tooltip extends React.Component{
	constructor(props){
		super(props)

		this.state = {
			tooltip: this.props.tooltip
		}
	}

	render(){
	  return (
	  	<div>
	  		<span className={'Tooltip'}>{this.state.tooltip}</span>
		</div>
	  )
	}
}


export default Tooltip

// const TooltipSpan = styled.span`
// 	visibility: hidden;
// 	opacity: 0;
// 	background: #484848;
// 	color: #FFF;
// 	text-align: left;
// 	border-radius: 2px;
// 	padding: 10px;
// 	top: 25px;
// 	font-size: 12px;
// 	pointer-events: none;
// 	left: -6px;
// 	width: 200px;
// 	margin-right: 15px;
// 	position: absolute;
// 	z-index: 1;
// 	transform: translateX(-5px);
// 	transition: 0.2s all cubic-bezier(0.215, 0.61, 0.355, 1);

// 	:after{
// 		content: "";
// 		display: block;
// 		width: 10px;
// 		height: 10px;
// 		background: #484848;
// 		transform: rotate(45deg);
// 		position: absolute;
// 		top: -3px;
// 		left: 10px;
// 	}
// `


// WEBPACK FOOTER //
// ./components/tooltip/tooltip.js